import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {WarrantyService} from './warranty.service';
import {WarrantyDatatableComponent} from './warranty-datatable.component';
import {WarrantyFormComponent} from './warranty-form.component';
import {FileModule} from '../file/file.module';
import {Warranty} from './warranty.model';

@NgModule({
  declarations: [
    WarrantyDatatableComponent,
    WarrantyFormComponent
  ],
  exports: [
    WarrantyDatatableComponent,
    WarrantyFormComponent
  ],
  imports: [
    SharedModule,
    FileModule
  ],
  providers: [
    WarrantyService,
    Warranty
  ]
})
export class WarrantyModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/warranty/warranty.module.ts